export const avisData = [
  {
    author: "Sophie Martin",
    rating: 5,
    date: "Il y a 2 semaines",
    comment: "Un endroit magnifique avec une cuisine excellente ! Le tartare de thon au curry était divin. La terrasse est très agréable et le personnel adorable. Je recommande vivement !"
  },
  {
    author: "Jean-Luc Dubois",
    rating: 5,
    date: "Il y a 1 mois",
    comment: "Meilleur restaurant de Moorea selon moi. Les crevettes flambées et le magret de canard sont incroyables. Ambiance décontractée, parking facile, que demander de plus ?"
  },
  {
    author: "Marie Lefebvre",
    rating: 5,
    date: "Il y a 3 semaines",
    comment: "Accueil chaleureux, cuisine généreuse et savoureuse. Le molten chocolate lava cake est à tomber ! Parfait pour un dîner en famille ou entre amis. LGBTQ+ friendly, on s'y sent bien."
  }
];